import { Question } from '../../utils/mathProblems';
import { AnswerState } from '../../hooks/useGameLogic';

interface Props {
  question: Question;
  onAnswer: (answer: string) => void;
  answerState: AnswerState;
  selectedAnswer: string | null;
  disabled: boolean;
}

const OPTION_LABELS = ['A', 'B', 'C', 'D'];

export default function AnswerOptions({ question, onAnswer, answerState, selectedAnswer, disabled }: Props) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {question.options.map((option, i) => {
        const isSelected = selectedAnswer === option;
        const isCorrect = option === question.correctAnswer;
        let bg = 'bg-white border-2 border-gray-200 text-gray-800 hover:border-green-400 hover:bg-green-50';

        if (answerState !== 'idle') {
          if (isCorrect) {
            bg = 'bg-green-500 border-2 border-green-500 text-white';
          } else if (isSelected && !isCorrect) {
            bg = 'bg-red-500 border-2 border-red-500 text-white';
          } else {
            bg = 'bg-gray-100 border-2 border-gray-200 text-gray-400';
          }
        }

        return (
          <button
            key={option}
            onClick={() => !disabled && onAnswer(option)}
            disabled={disabled}
            className={`relative flex items-center gap-3 p-3 rounded-xl text-left transition-all font-medium text-sm cursor-pointer ${bg} ${
              disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
          >
            <span
              className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full font-bold text-xs ${
                answerState !== 'idle'
                  ? isCorrect
                    ? 'bg-white/30 text-white'
                    : isSelected
                    ? 'bg-white/30 text-white'
                    : 'bg-gray-200 text-gray-500'
                  : 'bg-green-100 text-green-700'
              }`}
            >
              {OPTION_LABELS[i]}
            </span>
            <span className="flex-1 whitespace-nowrap overflow-hidden text-ellipsis">{option}</span>
            {answerState !== 'idle' && isCorrect && (
              <i className="ri-checkbox-circle-fill text-white text-base flex-shrink-0" />
            )}
            {answerState !== 'idle' && isSelected && !isCorrect && (
              <i className="ri-close-circle-fill text-white text-base flex-shrink-0" />
            )}
          </button>
        );
      })}
    </div>
  );
}
